import { ClipboardTextClock, AccountCogOutline, MapMarkerRadius, City, Domain } from 'mdi-material-ui'
import { FeatureCodes, moduleKeys } from 'src/components/common/featureData'

// import ExamSchedule from 'src/components/icons/ExamSchedule'
// import { ExamAttendance } from 'src/components/icons/examAttendance'

const redirectUrl = process.env.NEXT_PUBLIC_USER_REDIRECT_URL

export const assessmentMenu = {
  // [FeatureCodes.AAMS.academicTranscripts]: {
  //   title: 'Progress Report & Transcripts',
  //   icon: BadgeAccount,
  //   path: `${redirectUrl}assessment/progress-report-and-transcripts`,
  //   badgeColor: 'error',
  //   module: moduleKeys.assessment
  // },
  // [FeatureCodes.AAMS.admittedStudent]: {
  //   title: 'Admitted Student',
  //   icon: AccountSupervisor,
  //   path: `${redirectUrl}assessment/admitted-student/list`,
  //   badgeColor: 'error',
  //   module: moduleKeys.assessment
  // },
  // [FeatureCodes.AAMS.moduleAcademicReport]: {
  //   title: 'Module Academic Records',
  //   icon: FileMultiple,
  //   path: `${redirectUrl}assessment/module-academic-records`,
  //   badgeColor: 'error',
  //   module: moduleKeys.assessment
  // },
  // [FeatureCodes.AAMS.assessmentDashboard]: {
  //   title: 'Assessment Dashboard',
  //   icon: NoteMultipleOutline,
  //   path: `${redirectUrl}assessment/assessment-dashboard`,
  //   badgeColor: 'error',
  //   module: moduleKeys.assessment
  // },

  // [FeatureCodes.AAMS.examRoomManagement]: {
  //   title: 'Exam Room Management',
  //   icon: ClipboardTextClock,
  //   path: `${redirectUrl}assessment/exam-room-management`,
  //   badgeColor: 'error',
  //   module: moduleKeys.assessment
  // },
  // [FeatureCodes.AAMS.manageExamCategoryAndType]: {
  //   title: 'Manage Exam Category & Type',
  //   icon: ClipboardTextClock,
  //   path: `${redirectUrl}assessment/manage-exam-category-and-type`,
  //   badgeColor: 'error',
  //   module: moduleKeys.assessment
  // },
  // [FeatureCodes.AAMS.viewAndDownloadGraduation]: {
  //   title: 'View & Download Graduation List',
  //   icon: NotebookMultiple,
  //   path: `${redirectUrl}assessment/view-and-download-graduation-list`,
  //   badgeColor: 'error',
  //   module: moduleKeys.assessment
  // },

  // [FeatureCodes.AAMS.examSchedule]: {
  //   title: 'Exam Schedule',
  //   icon: ExamSchedule,
  //   path: `${redirectUrl}assessment/exam-schedule`,
  //   badgeColor: 'error',
  //   module: moduleKeys.assessment
  // },
  // [FeatureCodes.AAMS.viewExamAttendance]: {
  //   title: 'View Exam Attendance',
  //   icon: ExamAttendance,
  //   path: `${redirectUrl}assessment/view-exam-attendance`,
  //   badgeColor: 'error',
  //   module: moduleKeys.assessment
  // },

  // [FeatureCodes.AAMS.manageVenues]: {
  //   title: 'Manage Venues',
  //   icon: MapMarkerRadius,
  //   path: `${redirectUrl}assessment/manage-venues`,
  //   badgeColor: 'error',
  //   module: moduleKeys.assessment
  // },
  // [FeatureCodes.AAMS.manageFacilitator]: {
  //   title: 'Manage Facilitator & Invigilator',
  //   icon: AccountCogOutline,
  //   path: `${redirectUrl}assessment/manage-facilitator-and-invigilator`,
  //   badgeColor: 'error',
  //   module: moduleKeys.assessment
  // },
  // [FeatureCodes.AAMS.classManagement]: {
  //   title: 'Class Management',
  //   icon: AccountCogOutline,
  //   path: `${redirectUrl}assessment/class-management`,
  //   badgeColor: 'error',
  //   module: moduleKeys.assessment
  // }

  // -- Uncomment the below code to unhide the corporate assessment menu --

  [FeatureCodes.AAMS.viewExamAttendance]: {
    title: 'Corporate',
    icon: Domain,
    badgeColor: 'error',
    children: [
      {
        title: 'Assessment Dashboard',
        path: `${redirectUrl}assessment/corporate/assessment-dashboard`
      },
      {
        title: 'Exam Room Management',
        path: `${redirectUrl}assessment/corporate/exam-room-management`
      },
      {
        title: 'Exam Schedule',
        path: `${redirectUrl}assessment/corporate/exam-schedule`
      },
      {
        title: 'Module Academic Records',
        path: `${redirectUrl}assessment/corporate/module-academic-records`
      },
      {
        title: 'Progress Report & Transcripts',
        path: `${redirectUrl}assessment/corporate/progress-report-and-transcripts`
      },
      {
        title: 'View & Download Graduation List',
        path: `${redirectUrl}assessment/corporate/view-and-download-graduation-list`
      },
      {
        title: 'View Exam Attendance',
        path: `${redirectUrl}assessment/corporate/view-exam-attendance`
      }
    ],
    module: moduleKeys.assessment
  },

  // -- Uncomment the above code to unhide the corporate assessment menu --

  [FeatureCodes.AAMS.academicTranscripts]: {
    title: 'Retail',
    icon: City,
    badgeColor: 'error',
    children: [
      {
        title: 'Admitted Student',
        path: `${redirectUrl}assessment/admitted-student/list`
      },
      {
        title: 'Assessment Dashboard',
        path: `${redirectUrl}assessment/assessment-dashboard`
      },
      {
        title: 'Exam Room Management',
        path: `${redirectUrl}assessment/exam-room-management`
      },
      {
        title: 'Exam Schedule',
        path: `${redirectUrl}assessment/exam-schedule`
      },
      {
        title: 'Module Academic Records',
        path: `${redirectUrl}assessment/module-academic-records`
      },
      {
        title: 'Progress Report & Transcripts',
        path: `${redirectUrl}assessment/progress-report-and-transcripts`
      },
      {
        title: 'View & Download Graduation List',
        path: `${redirectUrl}assessment/view-and-download-graduation-list`
      },
      {
        title: 'View Exam Attendance',
        path: `${redirectUrl}assessment/view-exam-attendance`
      },
      {
        title: 'Class Management',
        path: `${redirectUrl}assessment/class-management`
      }
    ],
    module: moduleKeys.assessment
  },
  [FeatureCodes.AAMS.manageExamCategoryAndType]: {
    title: 'Manage Exam Category & Type',
    icon: ClipboardTextClock,
    path: `${redirectUrl}assessment/manage-exam-category-and-type`,
    badgeColor: 'error',
    module: moduleKeys.assessment
  },
  [FeatureCodes.AAMS.manageVenues]: {
    title: 'Manage Venues',
    icon: MapMarkerRadius,
    path: `${redirectUrl}assessment/manage-venues`,
    badgeColor: 'error',
    module: moduleKeys.assessment
  },
  [FeatureCodes.AAMS.manageFacilitator]: {
    title: 'Manage Facilitator & Invigilator',
    icon: AccountCogOutline,
    path: `${redirectUrl}assessment/manage-facilitator-and-invigilator`,
    badgeColor: 'error',
    module: moduleKeys.assessment
  }
}
